// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tradingview-widget-container[data-v-60ec205a]{height:46px;position:relative;top:0;margin:0 auto;-webkit-transition:top .3s ease;-o-transition:top .3s ease;transition:top .3s ease;pointer-events:all}", ""]);
// Exports
module.exports = exports;
